import {
  compose
} from 'recompose'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import moment from 'moment'
import classNames from 'classnames'

import {
  DatePicker,
  Button
} from '../../uiLib'

const getSunsctiptionTitle = subscriptionKey => {
  switch (subscriptionKey) {
    case 'sub_exp_date':
      return 'account_page-esi-subscription'
    case 'pats_exp_date':
      return 'account_page-pats-subscription'
    case 'reprog_exp_date':
      return 'account_page-pcm-subscription'
    case 'mdars_exp_date':
      return 'account_page-mdars-subscription'
    case 'training_exp_date':
      return 'account_page-training-subscription'
    case 'ids_exp_date':
      return 'account_page-ids-subscription-title'
  }
}


const mapStateToProps = (state, ownProps) => {
  return {
    initialValues: ownProps.subscriptions
  }
}

const ManageUserSubscription = props => (
  <form
    className="ma-subscriptions-date-form m-b-lg"
    onSubmit={props.handleSubmit(props.handleSubscriptionDateSubmit)}
    autoComplete="off"
  >
    { props.subscriptions ? (
      Object.keys(props.subscriptions).map((key, index) => (
        <div key={index} className="subscriptions-item m-b-md">
          <span><strong>{props.t(getSunsctiptionTitle(key))}</strong></span>
          <div className="m-b-sm">
            { props.t('common:subscriptions-status')}: {
              props.subscriptions[key] && moment(props.subscriptions[key]).isAfter(moment())
              ? <span className="has-text-success">{props.t('common:active')}</span>
              : <span className="has-text-danger">{props.t('common:inactive')}</span>
            }
          </div>
          <div className="m-b-md">
            <DatePicker
              id={key}
              name={key}
              selected={props.subscriptions[key]}
              formComponent
              dateFormat="MM/DD/YYYY hh:mm a"
              showMonthYearDropdown
              showTimeSelect
              placeholderText="Subcription was never purchased"
              minDate={moment()}
              maxDate={moment().add(2, 'y')}
              timeIntervals={60}
              disabled={props.loading}
            />
          </div>
        </div>
      ))
    ) : null }
    <div className="subscriptions-item">
      <Button
        outlined
        className={classNames({
          'is-default m-r-md': true,
          'is-loading': props.loading
        })}
        btType="default" >
        {props.t('common:submit')}
      </Button>
    </div>
  </form>
)

export default compose(
  connect(mapStateToProps, null),
  reduxForm({
    destroyOnUnmount: true,
    form: 'userSubscriptions'
  }),
)(ManageUserSubscription)



// WEBPACK FOOTER //
// ./components/Common/UserDetails/ManageUserSubscription.js